import { Injectable } from '@angular/core';
import { IFilterModel, FilterModel, IFilterQueryParams } from '../models/filter.models';
import { CacheService } from '../../core';

@Injectable()
export class FilterService {
	private readonly KEY: string = '$$filter_';

	constructor(private _cache: CacheService) { }

	get(identifier: string): IFilterQueryParams {
		const key = this.getKey(identifier);
		if (this._cache.has(key)) {
			return this._cache.get(key) as IFilterQueryParams;
		}

		let filter = <IFilterQueryParams>{ page: 1, pageSize: 25, filter: new FilterModel() };
		this._cache.set(key, filter);
		return filter;
	}

	set(identifier: string, filter: IFilterQueryParams) {
		this._cache.set(this.getKey(identifier), filter);
	}

	remove(identifier: string) {
		this._cache.remove(this.getKey(identifier));
	}

	private getKey(identifier: string) {
		return '$$filter_' + identifier;
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/filter.service.ts